import type { AgentsRepository } from '~~/core/ports/repositories/AgentsRepository';
import type { InjectionKey } from 'vue';

export type AgentSelectRepository = Pick<AgentsRepository, 'list'>;

export const agentSelectRepositoryKey: InjectionKey<AgentSelectRepository> =
	Symbol('AgentSelectRepository');
